function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './service-option-selector.scss';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { Controls } from 'shared/helper/form';
import useFilteredServiceOptions from 'researcher/hooks/use-filtered-service-options';
import { useTranslate } from 'shared/helper/translate';
var uniqueServiceOptionsOfFigureCount = function uniqueServiceOptionsOfFigureCount(t, filteredServiceOptions) {
  return _.uniqBy(filteredServiceOptions, function (_ref) {
    var figureCount = _ref.figureCount;
    return figureCount;
  }).map(function (_ref2) {
    var figureCount = _ref2.figureCount;
    return {
      label: t('%s figureFormatting-item-plural', figureCount),
      value: figureCount
    };
  });
};
var uniqueServiceOptionsOfTableCount = function uniqueServiceOptionsOfTableCount(t, filteredServiceOptions) {
  return _.uniqBy(filteredServiceOptions, function (_ref3) {
    var tableCount = _ref3.tableCount;
    return tableCount;
  }).map(function (_ref4) {
    var tableCount = _ref4.tableCount;
    return {
      label: t('%s tableformatting-item-plural', tableCount),
      value: tableCount
    };
  });
};
var uniqueServiceOptionsOfWordCount = function uniqueServiceOptionsOfWordCount(t, filteredServiceOptions) {
  var result = _.uniqBy(filteredServiceOptions, function (_ref5) {
    var wordCount = _ref5.wordCount;
    return wordCount.max;
  }).sort(function (a, b) {
    return a.wordCount.max < b.wordCount.max ? -1 : 1;
  }).map(function (_ref6) {
    var _ref6$wordCount = _ref6.wordCount,
      min = _ref6$wordCount.min,
      max = _ref6$wordCount.max;
    return {
      label: t('%s - %s words', [min, max]),
      value: max
    };
  });
  return result;
};
var uniqueServiceOptionsOfServiceIdentity = function uniqueServiceOptionsOfServiceIdentity(serviceOptions) {
  return _.uniqBy(serviceOptions, function (_ref7) {
    var serviceIdentity = _ref7.serviceIdentity;
    return serviceIdentity;
  }).map(function (_ref8) {
    var serviceIdentity = _ref8.serviceIdentity,
      name = _ref8.name;
    return {
      label: name,
      value: serviceIdentity
    };
  });
};
var CommonSelect = Controls.CommonSelect;
var ServiceOptionSelector = function ServiceOptionSelector(_ref9) {
  var serviceOptions = _ref9.serviceOptions,
    addServiceOption = _ref9.addServiceOption;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    addingServiceOption = _useState2[0],
    setAddingServiceOption = _useState2[1];
  var _useFilteredServiceOp = useFilteredServiceOptions({
      serviceOptions: serviceOptions
    }),
    clearServiceOptionSelection = _useFilteredServiceOp.clearSelection,
    filteredServiceOptions = _useFilteredServiceOp.filteredServiceOptions,
    filters = _useFilteredServiceOp.filters,
    requires = _useFilteredServiceOp.requires,
    setFilter = _useFilteredServiceOp.setFilter;
  var finishSelection = function finishSelection() {
    addServiceOption(filteredServiceOptions[0]);
    clearSelection();
  };
  var clearSelection = function clearSelection() {
    clearServiceOptionSelection();
    setAddingServiceOption(false);
  };
  if (serviceOptions.length === 0) {
    return null;
  }
  if (!addingServiceOption) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-link bg-transparent p-0 mt-2",
      onClick: function onClick() {
        return setAddingServiceOption(true);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-plus"
    }), " Add");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "service-option-selector"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-service-name"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('cancel'),
    type: "button",
    className: "float-end bg-transparent btn-link text-danger",
    onClick: clearSelection
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-xmark"
  })), "New service"), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-caret-up"
  }), /*#__PURE__*/React.createElement("div", {
    className: "service-option-selector-content pt-2"
  }, /*#__PURE__*/React.createElement(CommonSelect, {
    className: "mb-2",
    isClearable: false,
    value: filters.serviceIdentity,
    onChange: setFilter.serviceIdentity,
    options: uniqueServiceOptionsOfServiceIdentity(serviceOptions),
    placeholder: "Service name"
  }), filters.serviceIdentity && requires.wordCount ? /*#__PURE__*/React.createElement(CommonSelect, {
    className: "mb-2",
    isClearable: false,
    isDisabled: !requires.wordCount,
    value: filters.wordCount,
    onChange: setFilter.wordCount,
    options: uniqueServiceOptionsOfWordCount(t, filteredServiceOptions),
    placeholder: "Word Count"
  }) : null, filters.serviceIdentity && (requires.figureCount || requires.tableCount) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CommonSelect, {
    className: "mb-2",
    isClearable: false,
    isDisabled: !requires.figureCount,
    value: filters.figureCount,
    onChange: setFilter.figureCount,
    options: uniqueServiceOptionsOfFigureCount(t, filteredServiceOptions),
    placeholder: "Figure Count"
  }), /*#__PURE__*/React.createElement(CommonSelect, {
    className: "mb-2",
    isClearable: false,
    isDisabled: !requires.tableCount,
    value: filters.tableCount,
    onChange: setFilter.tableCount,
    options: uniqueServiceOptionsOfTableCount(t, filteredServiceOptions),
    placeholder: "Table Count"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "actions text-white"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: filteredServiceOptions.length !== 1,
    type: "button",
    className: "btn btn-small btn-primary",
    onClick: finishSelection
  }, "Done"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "ms-2 btn btn-small btn-secondary",
    onClick: clearSelection
  }, "Cancel"))));
};
export default ServiceOptionSelector;